module.exports = __webpack_public_path__ + "img/IMG_4707.9702aac9.jpg";